import type { RouteObject } from 'react-router-dom-v5-compat';

import config from '@/config';

/**
 * @deprecated This layout is slowly being replaced with the new full-width layout.
 */
export const legacySplitLayoutRoutes = [
    config.routes.changelog,
    config.routes.importExport,
    config.routes.tagsSettings,
    config.routes.groupsVisibilitySettings,
].map(route => ({ path: route })) satisfies RouteObject[];

/**
 * @deprecated Non-admins get the full-width layout here because the side panel graphs are admin-only.
 */
export const legacyAdminSplitLayoutRoutes = [
    config.routes.securityAudit,
    config.routes.securityAuditLevel,
    config.routes.securityAuditAge,
    config.routes.securityAuditLeaks,
].map(route => ({ path: route })) satisfies RouteObject[];
